import { useContext } from 'react';

import { GaugeChartBaseColorContext } from '../contexts/GaugeChartBaseColorContext.js';

export const useGaugeChartBaseColorContext = () =>
  useContext(GaugeChartBaseColorContext);
